import { useMemo } from "react";
const getPictureUuidsForTemplateOrderLine = (orderLine) => {
    /** @ts-ignore-next-line */
    const userResources = orderLine.template.data.userResources;
    const pictures = {};
    for (const resourceId in userResources) {
        const resource = userResources[resourceId];
        if (resource.type !== "IMAGE") {
            continue;
        }
        console.log("User resource by id", resourceId, userResources);
        const imageUuid = resource === null || resource === void 0 ? void 0 : resource.image.uuid;
        console.log("Unique", imageUuid);
        if (imageUuid) {
            pictures[imageUuid] = true;
        }
    }
    return Object.keys(pictures);
};
const useUniqueShoppingCartPictures = (orderLines) => {
    const uniquePictures = useMemo(() => {
        const seen = new Set();
        orderLines.forEach((line) => {
            console.log("Checking order line", line);
            let pictures = [];
            if ("template" in line) {
                pictures = getPictureUuidsForTemplateOrderLine(line);
            }
            pictures.forEach((uuid) => seen.add(uuid));
        });
        return Array.from(seen);
    }, [orderLines]);
    console.log("Unique pictures", uniquePictures);
    return uniquePictures;
};
export default useUniqueShoppingCartPictures;
